import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';   
import { BaseApiService } from '../../core/services/base-api.service';
import { AppConfigService } from '../../core/services/app-config.service';
import {
    CategoryChartData    
} from './dashboard.model';

@Injectable({
    providedIn: 'root'
})
export class DashboardService extends BaseApiService {
    getSubmissionData: any;
    constructor(
        http: HttpClient,
        appConfigService: AppConfigService
    ) {
        super(http, appConfigService);
    }

    getAuthorPoolData(): Observable<CategoryChartData[]> {
        return this.get<CategoryChartData[]>('dashboard/author-pool');
    }

    getPublishedArticlesData(): Observable<CategoryChartData[]> {
        return this.get<CategoryChartData[]>('dashboard/published-articles');
    }

    getDaysToPublishData(): Observable<CategoryChartData[]> {
        return this.get<CategoryChartData[]>('dashboard/days-to-publish');        
    }

    getRevenueData(): Observable<CategoryChartData[]> {
        return this.get<CategoryChartData[]>('dashboard/revenue');        
    } 
}